<template>
  <section class="section-extras mb-4" v-if="extras && extras.length > 0">
    <h4 class="booking-title">{{ $t('message.booking.payment_step.extras') }}</h4>
    <div class="card shadow-sm">
      <div class="card-body">
        <div v-for="(extra, index) in extras" v-if="!extra.is_grouped">
          <div class="exp"
               :class="{ 'mb-3' : (index + 1) < extras.length }">
            <div class="checkbox">
              <input type="radio"
                     name="extra"
                     :ref="'extra' + extra.id"
                     :id="'extra' + extra.id"
                     :value="extra"
                     v-model="preCheckoutData.extra"
                     @click="applyExtras($event, extra)"/>
              <label :for="'extra'+extra.id" class="mb-0 d-flex">
                <span class="justify-content-center align-self-center"><!-- This span is needed to create the "checkbox" element --></span>
                <div class="pl-2">
                  {{ extra | multiLangName }} <br>
                  {{ extra.cost | currency }} (+{{ extra.work_hour }} {{ $tc('message.hour', extra.work_hour) }})
                </div>
              </label>
            </div>
          </div>
        </div>
        <section class="mt-3" v-if="preCheckoutData.grouped_extras.length > 0">
          <div v-for="(groupExtras, index) in preCheckoutData.grouped_extras">
            <div class="d-flex">
              <div class="flex-grow-1">
                <div class="exp">
                  <div class="checkbox">
                    <input type="radio"
                           name="extra"
                           :ref="'extra' + groupExtras[dynamicIndex[index]].id"
                           :id="`groupExtra${dynamicIndex[index]}`"
                           :value="groupExtras[dynamicIndex[index]]"
                           v-model="preCheckoutData.extra"
                           @click="applyExtras($event, groupExtras[dynamicIndex[index]])"/>
                    <label :for="`groupExtra${dynamicIndex[index]}`" class="mb-0 d-flex">
                      <span class="justify-content-center align-self-center"><!-- This span is needed to create the "checkbox" element --></span>
                      <div class="pl-2">
                        {{ groupExtras[dynamicIndex[index]] | multiLangName }} <br>
                        {{ groupExtras[dynamicIndex[index]].cost | currency }} (+{{
                        groupExtras[dynamicIndex[index]].work_hour }} {{ $tc('message.hour',
                        groupExtras[dynamicIndex[index]].work_hour) }})
                      </div>
                    </label>
                  </div>
                </div>
              </div>
              <div>
                <button class="btn btn-info" @click="decreaseIndex(index)"><i class="fas fa-minus"></i></button>&nbsp;&nbsp;
                <button class="btn btn-info" @click="increaseIndex(index)"><i class="fas fa-plus"></i></button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'

  export default {
    props: {
      hasProfessional: Boolean
    },
    data () {
      return {
        extras: null,
        groupedExtras: null,
        dynamicIndex: []
      }
    },
    computed: {
      ...mapGetters({
        appliedExtras: 'extras/getAppliedExtras',
        globalState: 'globalVal/getState',
        preBookingData: 'booking/getPreBookingData',
        preCheckoutData: 'booking/getPreCheckoutData',
        selectedProfessional: 'booking/getSelectedProfessional'
      }),
      ...mapState('booking', ['tmpPreCheckoutData'])
    },
    watch: {
      extras () {
        if (this.extras !== null && this.extras.length > 0 && this.appliedExtras && this.appliedExtras.extra_id) {
          let mKey = 0
          let mIndex = 0
          for (let key in this.groupedExtras) {
            for (let index in this.groupedExtras[key]) {
              const itemExtra = this.groupedExtras[key][index]
              if (itemExtra.id === this.appliedExtras.extra_id) {
                mKey = Number(key)
                mIndex = Number(index)
                break
              }
            }
          }
          this.dynamicIndex[mKey] = mIndex
          setTimeout(() => {
            if (this.appliedExtras.extra_id && this.preCheckoutData.extras.length > 0) {
              this.$refs['extra' + this.appliedExtras.extra_id][0].click()
            }
          }, 500)
        }
      }
    },
    methods: {
      decreaseIndex (index) {
        if (this.dynamicIndex[index] > 0) {
          this.dynamicIndex[index] -= 1
          this.dynamicIndex = [...this.dynamicIndex]
          this.clearExtras(index, this.dynamicIndex[index])
        }
      },
      increaseIndex (index) {
        if (this.dynamicIndex[index] < (this.preCheckoutData.grouped_extras[index].length - 1)) {
          this.dynamicIndex[index] += 1
          this.dynamicIndex = [...this.dynamicIndex]
          this.clearExtras(index, this.dynamicIndex[index])
        }
      },
      applyExtras (event, extra) {
        console.log('check event', event)
        console.log('check extra', extra)
        let hasAppliedExtras = false
        let workHour = Number(this.preBookingData.init_work_hour)
        if (this.preCheckoutData.extra === extra) {
          if (event) {
            event.target.checked = false
          }
          this.preCheckoutData.extra = null
        } else {
          hasAppliedExtras = true
          if (event) {
            event.target.checked = true
          }
          workHour += Number(extra.work_hour)
        }
        workHour = workHour.toFixed(1)
        // Apply extras
        const submitData = {
          extra_id: extra.id,
          province_id: this.preBookingData.province_id,
          work_hour: workHour
        }
        this.$store.dispatch('extras/APPLY_EXTRAS', submitData)
        // Update work hours & has applied extras
        this.$store.commit('booking/UPDATE_PRE_BOOKING_DATA', {key: 'work_hour', value: workHour.toString()})
        this.$store.commit('extras/SET_HAS_APPLIED_EXTRAS', hasAppliedExtras)
      },
      clearExtras (parentIndex, childIndex) {
        if (this.preCheckoutData.extra && this.preCheckoutData.extra.service_id === this.preCheckoutData.grouped_extras[parentIndex][childIndex].service_id) {
          this.preCheckoutData.extra = null
          let hasAppliedExtras = false
          let workHour = Number(this.preBookingData.init_work_hour)
          workHour = workHour.toFixed(1)
          // Apply extras
          const submitData = {
            extra_id: null,
            province_id: this.preBookingData.province_id,
            work_hour: workHour
          }
          this.$store.dispatch('extras/APPLY_EXTRAS', submitData)
          // Update work hours & has applied extras
          this.$store.commit('booking/UPDATE_PRE_BOOKING_DATA', {key: 'work_hour', value: workHour.toString()})
          this.$store.commit('extras/SET_HAS_APPLIED_EXTRAS', hasAppliedExtras)
        }
      }
    },
    mounted () {
      if (this.preCheckoutData) {
        if (!this.hasProfessional) {
          this.extras = this.preCheckoutData.extras
          this.groupedExtras = this.preCheckoutData.grouped_extras
        } else if (this.hasProfessional && this.preBookingData.province_id) {
          this.extras = []
          this.groupedExtras = this.preCheckoutData.grouped_extras
          for (let key in this.preCheckoutData.extras) {
            const extraData = this.preCheckoutData.extras[key]
            if (!extraData.province_id && extraData.service_id) {
              for (let professionalService of this.selectedProfessional.professional_services) {
                if (professionalService.service_id === extraData.service_id) {
                  this.extras.push(extraData)
                }
              }
            } else if (extraData.province_id === this.preBookingData.province_id) {
              this.extras.push(extraData)
            }
          }
        }

        // Set dynamic index
        if (this.groupedExtras && this.groupedExtras.length > 0) {
          for (let key in this.groupedExtras) {
            this.dynamicIndex[Number(key)] = 0
          }
        } // End check extras
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/booking/components/ExtraForm.vue